import React, { Component } from "react";
import { renderLogicUtil } from "views/Pma/RenderLogicUtil";
import "./print.scss";

class DashboardQRCode extends Component {
  render() {
    const { isHomeownerAbsentie } = renderLogicUtil;

    let { smallerQR, currentArea, printVersion } = this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = this.props.agentData;
    let { homeOwnerURLID, homeOwnerURLQRCodePath, homeOwnerURL } =
      this.props.hoData;

    if (listgenUserID === "101") {
      homeOwnerURL = "https://ourproperty.info/c12p";
      homeOwnerURLID = "c12p";
      homeOwnerURLQRCodePath =
        "https://lg-qr-code-images.s3.amazonaws.com/c12p.png";
    }
    let largerQRCode = false;
    if (listgenUserID === "100030") {
      largerQRCode = true;
    }
    //updating global note
    let lowerQRCodeStyles;

    // = "top-305-qr-section";
    // if (listgenUserID === "x105642" || listgenUserID === "x104835") {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // } else if (
    //   currentArea &&
    //   currentArea.globalNoteCurrent &&
    //   currentArea.globalNoteCurrent.length > 600
    // ) {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // }
    // if (listgenUserID === "105805" || listgenUserID === "106024") {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // } else if (listgenUserID === "105794" || listgenUserID === "106652") {
    //   lowerQRCodeStyles = "qr-code-top-345";
    // } else if (
    //   listgenUserID === "104835" ||
    //   listgenUserID === "107019" ||
    //   listgenUserID === "105790"
    // ) {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // }
    if (listgenUserID === "x100411") {
      return "";
    } else {
      return (
        <div
          className={`${
            printVersion
              ? "print-dashboard-qr-code"
              : "editor-dashboard-qr-code"
          } ${smallerQR && "smaller-qr-section-v2"} ${lowerQRCodeStyles}`}
        >
          <div className="qr-code-col1">
            <div
              className={`bubble-arrow-container ${
                smallerQR && "smaller-qr-arrow-img"
              } ${largerQRCode && "larger-qr-arrow-img"}`}
            >
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/doublearrow_4-qrcode_gold-01.png"
                alt="Double Arrow March"
              />
            </div>
          </div>
          <div className="qr-code-col2">
            <div className="qr-code-content-row">
              <div
                className={`bubble-qr-container ${
                  smallerQR && "smaller-qr-img"
                } ${largerQRCode && "larger-qr-img"}`}
              >
                {listgenUserID === "101566" ? (
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/gummow-bros-qr-cropped.png"
                    className="bubble-qr-image auto-width-qr"
                    alt="Gummow brothers QR code"
                  />
                ) : listgenUserID === "100411" ? (
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/040323_Garret-MC_QRcode_500px.jpg"
                    className="bubble-qr-image"
                    alt="Garrett QR Code"
                  />
                ) : (
                  <img
                    src={homeOwnerURLQRCodePath}
                    className="bubble-qr-image"
                    alt="QR Code"
                  />
                )}
              </div>
              <div className="qr-code-text">
                {listgenUserID === "106531" ? (
                  <p>
                    Curious what your home is worth?
                    <br /> Scan the QR code to find out!
                    <a
                      href={homeOwnerURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        OurProperty.info/{homeOwnerURLID}
                      </span>
                    </a>
                  </p>
                ) : listgenUserID === "100030" ? (
                  <p>
                    Your Complimentary Home Valuation:
                    <br /> Simply scan the QR code or go to
                    <a
                      href="https://www.randallrealty.com/valuation-form/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        randallrealty.com/valuation-form
                      </span>
                    </a>
                  </p>
                ) : listgenUserID === "101566" ? (
                  <p className="qr-text-neg-mar-17">
                    Your Complimentary Home Valuation:
                    <br /> Simply scan the QR code or go to
                    <a
                      href={homeOwnerURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        www.gummowbrothers.com/home-valuation
                      </span>
                    </a>
                  </p>
                ) : listgenUserID === "100411" ? (
                  <p>
                    Do you know what your home is worth? Simply scan the QR code
                    to the left or go to
                    <a
                      href="https://hmbt.co/DcY6Gq"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        https://hmbt.co/DcY6Gq
                      </span>
                    </a>
                  </p>
                ) : listgenUserID === "x100411" ? (
                  <p className="smaller-qr-code-text">
                    P.S. I am currently working with a qualified buyer looking
                    for a fixer in Hidden Valley. If you would consider an offer
                    on your home, please call me to discuss if your property
                    might be a fit for my client.
                    <a
                      href="https://hmbt.co/DcY6Gq"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        https://hmbt.co/DcY6Gq
                      </span>
                    </a>
                  </p>
                ) : (
                  <p>
                    Scan Here to Request a Precise Home Valuation
                    <br />
                    Or go to
                    <a
                      href={homeOwnerURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="qr-code-link">
                        OurProperty.info/{homeOwnerURLID}
                      </span>
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default DashboardQRCode;
